/**
 * Service Requests Feature Flags
 * Centralized location for all feature flags used in the service-requests module
 */

/**
 * Feature flag for SAT (Satisfaction) column
 * Controls visibility of satisfaction rating features across service request components
 */
export const ENABLE_SAT_COLUMN = false;

/** SR agent voice (OpenAI Whisper STT on backend) — matches SR_VOICE_DEFAULT_MIME */
export const SR_VOICE_ENABLED = true;
export const SR_VOICE_DEFAULT_MIME = "audio/webm";
export const SR_VOICE_RECORDER_TIMESLICE_MS = 250;
export const SR_VOICE_PLACEHOLDER = "🎤 Transcribing…";

/** SR agent chat chrome */
export const SR_CHAT_ACCENT = "#3A80F4";
export const SR_CHAT_ACCENT_HOVER = "#2563EB";
export const SR_CHAT_SUGGESTIONS = [
    "Find requests for Kumar",
    "Break down by status (chart)",
    "Break down by assignee",
    "Search by tracking ID",
];

/** Voter photo + face enroll guard (server cutoff 0.5 vs normal search 0.6) */
export const SR_PROFILE_PHOTO_UPLOAD_DIR = "sr_profile_photos";
export const SR_PROFILE_PHOTO_BUCKET = "urn-assets";
export const SR_FACE_CHECK_PATH = "unified_service_request/sr-face-check";
export const SR_FACE_DECISION_PATH = "unified_service_request/sr-face-decision";
export const SR_FACE_DECISIONS = ["replace", "keep"] as const;

